import styled from 'styled-components'
import Icon from '@mdi/react'

import theme from 'theme_'
import CommonButton from 'components/Button/CommonButton'
import { Font14 } from 'components/Typography'

export const ClaimDeviceErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  padding-bottom: 58px;
  min-height: 350px;
`

export const ClaimDeviceErrorDescription = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  ${Font14};
`

export const ClaimDeviceErrorIcon = styled(Icon)`
  color: ${theme.colors.error};
`

export const ClaimDeviceErrorSpan = styled.span`
  display: block;
  text-align: center;
`

export const ClaimDeviceErrorRetryButton = styled(CommonButton)`
  min-width: 186px;
  height: 40px;
`
